var map = {
	"./appetizers.png": 1423,
	"./desserts.png": 4186,
	"./drinks.png": 8045,
	"./food-menu.png": 7199,
	"./kids-menu.png": 6347,
	"./lunch-menu.png": 9462,
	"./salads.png": 6241,
	"./sides.png": 2455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3766;